<template>
  <div>
    <LmListV2
      ref='LmFormBuilderListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Formularios',
      gqlField: 'formbuilderLmListV2',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[FormbuilderESSortEnum]) {
        formbuilderLmListV2(
          titleList: "Listado de Formularios"
          aggs: []
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/FormBuilderUi/edit/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"},{to:"/FormBuilderUi/preview/:_id",tooltip:"Previsualizar",fontAwesomeIcon:"eye"}]
          lmModalActions: []
          buttonLinks: [{value:"Nuevo",to:"/formbuilderui/",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info",buttonColor:"#17a2b8",softPermissions:{}}]
          ) {
          count
          searcher
          tableItemsTotal
          titleList
          filter {
            aggregatesToSelect
          }
          table {
            items {
              createdAt,
              updatedAt,
              pageTitleData,
              actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
          }
        }`,
      searchOnFieldsSelected: [
        'id',
        'pageTitleData',
        'alias',
        'lumbreInternal',
        'createdAt',
        'updatedAt',
        'actions',
        'createdBy',
        'updatedBy'
      ],
      searchOnFieldsToSelected: [
        'createdAt',
        'updatedAt',
        'actions',
        'pageTitleData'
      ],
      items: [
        {
          name: 'id'
        },
        {
          name: 'pageTitleData'
        },
        {
          name: 'alias'
        },
        {
          name: 'lumbreInternal'
        },
        {
          name: 'createdAt'
        },
        {
          name: 'updatedAt'
        },
        {
          name: 'actions'
        },
        {
          name: 'createdBy'
        },
        {
          name: 'updatedBy'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [
        {
          key: 'pageTitleData',
          label: 'Titulo',
          sortable: false
        },
        {
          key: 'createdAt',
          label: 'Creado',
          sortable: true
        },
        {
          key: 'updatedAt',
          label: 'Actualizado',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }]
    }
  }
}
</script>
